function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import FullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";
import SelectableTagsFieldsConfig from "segments/desktop/core-components/selectable-tag/fields-config";
import assetFieldsConfig from "components/core/asset/fields-config";
import { newBrandColors } from "constants/color-picker-constants";
import { AZURE_RADIANCE, LAVENDER_PURPLE_COLOR_NAME, TURQUOISE_BRIGHT_COLOR_NAME } from "styles/color-consts";
import { NAME_TO_ICON } from "segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/consts";
const { tagValue, galleryImage, initiallySelected, tagBackgroundColor } = SelectableTagsFieldsConfig, restOfTagsConfig = _object_without_properties(SelectableTagsFieldsConfig, [
    "tagValue",
    "galleryImage",
    "initiallySelected",
    "tagBackgroundColor"
]);
const TAGS_ICON_OPTIONS = Object.keys(NAME_TO_ICON).map((name)=>({
        text: name,
        value: name
    }));
export default {
    type: FIELD_TYPES.NESTED,
    label: "Side By Side Paragraph And Tags",
    fields: {
        tagsTitle: {
            type: FIELD_TYPES.TEXT,
            label: "Tags Title"
        },
        gap: {
            type: FIELD_TYPES.TEXT,
            label: "Space between paragraph and tags"
        },
        useTagsClusterCTA: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Use tags cluster CTA"
        },
        tags: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Selectable Tags",
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: _object_spread_props(_object_spread({}, restOfTagsConfig), {
                    tagColor: {
                        type: FIELD_TYPES.COLOR_PICKER,
                        label: "Color",
                        possibleColors: [
                            ...newBrandColors,
                            LAVENDER_PURPLE_COLOR_NAME,
                            "lipstick",
                            "bubble",
                            TURQUOISE_BRIGHT_COLOR_NAME,
                            "purple",
                            "orange",
                            AZURE_RADIANCE
                        ]
                    },
                    tagImage: {
                        type: FIELD_TYPES.NESTED,
                        label: "Tag Image",
                        fields: _object_spread({}, assetFieldsConfig.image.fields)
                    },
                    tagIconName: {
                        type: FIELD_TYPES.COMBO,
                        label: "Tag Icon",
                        options: TAGS_ICON_OPTIONS
                    }
                })
            }
        },
        fullParagraph: {
            type: FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: FullParagraphFieldsConfig
        }
    }
};
